import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Sort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest, map, Observable } from 'rxjs';
import { ConfirmDialogComponent, Logger, OrganizationService } from 'src/app/@shared';
import { DEFAULT_SNACKBAR_CONFIG } from 'src/app/@shared/constants/site.constants';
import { OfferAsset, ProductAssetsService, ProductAddAssetComponent } from '../..';
import { AuthorizeControlService } from 'pr1-ui-components';

const log = new Logger('ProductAssetListComponent');

@Component({
  selector: 'app-product-asset-list',
  templateUrl: './product-asset-list.component.html',
  styleUrls: ['./product-asset-list.component.scss']
})

export class ProductAssetListComponent implements OnInit {
  private assetsUrl: string = '';
  viewModel$ = combineLatest([
    this.productassetService.isLoading$,
    this.productassetService.viewMode$,
    this.productassetService.productId$,
    this.organizationService.assetsUrl$,
  ]).pipe(
    map(([isLoading, viewMode, productId, assetsUrl]) => {
      this.assetsUrl = assetsUrl;
      return { isLoading, viewMode, productId, assetsUrl }
    }),
  );

  filtersForm = new FormGroup({
    search: new FormControl(),
  });

  @ViewChild('assetTable', { static: false }) assetTable: any;
  @ViewChild('assetCards', { static: false }) assetCards: any;
  assetsList: OfferAsset[] = [];

  constructor(private productassetService: ProductAssetsService<OfferAsset>,
    private organizationService: OrganizationService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private router: Router,
    private matSnackBar: MatSnackBar,
    private authorizationService: AuthorizeControlService) { }

  ngOnInit(): void {
    log.debug('init');
    this.clearSearch();
    // get the product id from the parent route
    this.productassetService.productId = this.route.snapshot.params['productId'];
    this.productassetService.assets$.subscribe((data) => {
      this.assetsList = data;
    });
  }


  onSearch(event: any) {
    this.productassetService.search(event.target.value);
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(ProductAddAssetComponent, {
      width: '80%',
      height: '90%',
      data: { productId: this.route.snapshot.params['productId'] }
    });
  }

  diassociateAssets() {
    let selectedRecords: any;
    if (this.assetTable) {
      selectedRecords = this.assetTable.getSelectedSectionRecords();
    } else if (this.assetCards) {
      selectedRecords = this.assetCards.getSelectedSectionRecords();
    }
    if (selectedRecords && selectedRecords.length > 0) {
      const confirmDialog = this.dialog.open(ConfirmDialogComponent, {
        data: {
          title: 'Confirm Delete',
          message: `Do you want to remove from asset?`,
        },
        disableClose: true,
      });

      confirmDialog.afterClosed().subscribe(
        confirmResult => {
          if (confirmResult) {
            const assets = selectedRecords.map((x: any) => x.Detail.Id)
            this.productassetService.disassociateAssetToProduct(assets).subscribe({
              next: () => {
                this.matSnackBar.open(`Asset deleted`, 'OK', DEFAULT_SNACKBAR_CONFIG);
                if (this.assetTable) {
                  this.assetTable.clearSelection();
                } else if (this.assetCards) {
                  this.assetCards.clearSelection();
                }
                this.productassetService.reload();
                this.router.navigate([`../`, `product-assets`], { relativeTo: this.route });
              },
              error: (error) => {
                log.error('Error adding store to version', error);

                if (error.error.value) {
                  throw new Error(error.error.value);
                } else {
                  throw new Error(error.message);
                }
              }
            });
          }
        });
    }
  }

  clearSearch() {
    this.filtersForm.controls.search.setValue('');
    this.productassetService.search('');
  }

  cancel(): void {
    this.productassetService.reload();
    this.router.navigate([`../../`], { relativeTo: this.route });
  }

  toggleView(mode: string) {
    this.productassetService.toggleViewMode(mode);
  }

  
  canEdit(): boolean {
    const hasAccess = this.authorizationService.checkAccess('edit||offermang');
    return hasAccess;
  }

}
